import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../public/WAW_Logo_Navbar.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "navbar-header" }
const _hoisted_3 = { class: "extremely-small-screen" }
const _hoisted_4 = { class: "lang-item" }
const _hoisted_5 = { class: "text-select" }
const _hoisted_6 = { class: "lang-dropdown-option" }
const _hoisted_7 = { class: "text-dropdown" }
const _hoisted_8 = { class: "lang-item" }
const _hoisted_9 = ["alt", "src"]
const _hoisted_10 = {
  key: 0,
  class: "text-select"
}
const _hoisted_11 = { class: "lang-dropdown-option" }
const _hoisted_12 = ["alt", "src"]
const _hoisted_13 = { class: "text-dropdown" }
const _hoisted_14 = { class: "navbar-small-screen-container" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-fullscreen" }
const _hoisted_17 = { class: "lang-item" }
const _hoisted_18 = { class: "text-select" }
const _hoisted_19 = { class: "lang-dropdown-option" }
const _hoisted_20 = { class: "text-dropdown" }
const _hoisted_21 = { class: "lang-item" }
const _hoisted_22 = ["alt", "src"]
const _hoisted_23 = { class: "text-select" }
const _hoisted_24 = { class: "lang-dropdown-option" }
const _hoisted_25 = ["alt", "src"]
const _hoisted_26 = { class: "text-dropdown" }
const _hoisted_27 = {
  key: 1,
  id: "toggleSidebar"
}
const _hoisted_28 = { class: "text-fullscreen" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const hasSetSidebarView = ref(false);
const windowWidth = ref(window.innerWidth);

const conflicts = [
  { value: '1948-arab-israeli-war', name: '1948 Arab-Israeli War' },
  { value: 'suez-crisis', name: '1956 Suez Crisis' },
];

const languages = [
  { value: 'en', name: 'English' },
  { value: 'he', name: 'עברית' },
];

const store = useStore();
const route = useRoute();
const { locale, t } = useI18n();

onMounted(() => {
  const navbar = document.getElementById('navbar');

  if (window.innerWidth < 899) {
    store.commit('setView', 'map');
  }
  else if (window.innerWidth >= 899) {
    store.commit('setView', 'sidebar');
  }

  if (navbar) {
    const observer = new MutationObserver(() => {
      const isOpen = navbar.classList.contains('in') || navbar.classList.contains('collapsing');
      store.commit('setMobileMenu', isOpen);
    });

    observer.observe(navbar, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('resize', handleResize);
});

const selectedWar = computed({
  get: () => store.state.war,
  set: (value) => store.commit('changeConflict', value)
});

const handleResize = () => {
  windowWidth.value = window.innerWidth;
  if (!hasSetSidebarView.value && window.innerWidth < 899) {
    store.commit('setView', 'map');
    hasSetSidebarView.value = true;
  }
  else if (window.innerWidth >= 899) {
    store.commit('setView', 'sidebar');
    hasSetSidebarView.value = false;
  }
};

const openFullscreen = () => {
  const screen = document.documentElement;

  if (!document.fullscreenElement) {
    screen.requestFullscreen();
  }
  else {
    document.exitFullscreen();
  }
};

const toggleSidebar = (state: string) => {
  store.commit('setView', state);
};

const formatWarName = (warName: string) => {
  return warName.split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", {
      class: _normalizeClass(["navbar navbar-default", { 'dark-mode': _unref(store).state.dark }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[15] || (_cache[15] = _createElementVNode("button", {
            type: "button",
            class: "navbar-toggle",
            "data-toggle": "collapse",
            "data-target": "#navbar"
          }, [
            _createElementVNode("span", { class: "icon-bar" }),
            _createElementVNode("span", { class: "icon-bar" }),
            _createElementVNode("span", { class: "icon-bar" })
          ], -1)),
          _createVNode(_component_router_link, {
            to: "/",
            class: _normalizeClass(["navbar-brand", { 'dark-mode': _ctx.$store.state.dark }])
          }, {
            default: _withCtx(() => [
              _cache[12] || (_cache[12] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Project: World at War Logo"
              }, null, -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('nav.home')), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createElementVNode("ul", {
            class: _normalizeClass(["nav navbar-nav mobile-navbar", { 'dark-mode': _unref(store).state.dark }])
          }, [
            (_unref(route).path === '/')
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass([_ctx.$store.state.locale == 'en' ? 'dropdown-padding' : 'hidden'])
                }, [
                  _createVNode(_component_Dropdown, {
                    class: _normalizeClass(["locale-switcher p-dropdown-trigger-icon", { 'dark-mode': _unref(store).state.dark }]),
                    panelClass: { 'dark-mode': _unref(store).state.dark },
                    modelValue: selectedWar.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWar).value = $event)),
                    options: conflicts,
                    optionLabel: "name",
                    optionValue: "value"
                  }, {
                    value: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(windowWidth.value > 460 ? formatWarName(_unref(store).state.war) : _unref(t)('nav.conflict')), 1)
                      ])
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                        _createElementVNode("span", { class: "p-dropdown-trigger-icon" }, [
                          _createElementVNode("i", { class: "pi-angle-down" })
                        ])
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["class", "panelClass", "modelValue"])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              class: _normalizeClass([_ctx.$store.state.war == '1948-arab-israeli-war' ? 'dropdown-padding' : 'hidden'])
            }, [
              _createVNode(_component_Dropdown, {
                class: _normalizeClass(["locale-switcher p-dropdown-trigger-icon", { 'dark-mode': _unref(store).state.dark }]),
                panelClass: { 'dark-mode': _unref(store).state.dark },
                modelValue: _unref(locale),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
                options: languages,
                optionLabel: "name",
                optionValue: "value"
              }, {
                value: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      class: "flag-select",
                      alt: slotProps.placeholder,
                      src: require(`@/assets/icons/${slotProps.value}.svg`)
                    }, null, 8, _hoisted_9),
                    (windowWidth.value > 460)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(slotProps.value.toUpperCase()), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      class: "flag-dropdown",
                      alt: slotProps.option.name,
                      src: require(`@/assets/icons/${slotProps.option.value}.svg`)
                    }, null, 8, _hoisted_12),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "p-dropdown-trigger-icon" }, [
                      _createElementVNode("i", { class: "pi-angle-down" })
                    ])
                  ], -1))
                ]),
                _: 1
              }, 8, ["class", "panelClass", "modelValue"])
            ], 2)
          ], 2)
        ]),
        _createElementVNode("div", {
          id: "navbar",
          class: _normalizeClass(["navbar-collapse collapse", { 'dark-mode': _unref(store).state.dark }])
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              _createElementVNode("ul", {
                class: _normalizeClass(["mr-auto nav navbar-nav navbar-links", {'dark-mode': _unref(store).state.dark }])
              }, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    style: {"display":"none"},
                    to: "/"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("Home")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "about" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('nav.about')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "sources" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('nav.sources')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "legal" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('nav.legal')), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 2)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("ul", {
                class: _normalizeClass(["mr-auto nav navbar-nav navbar-links", {'dark-mode': _unref(store).state.dark }])
              }, [
                (_unref(route).path === '/')
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _createElementVNode("a", {
                        class: "medium-toggle-sidebar",
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSidebar(_unref(store).state.view == 'map' ? 'sidebar' : 'map')))
                      }, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "glyphicon glyphicon-align-right" }, null, -1)),
                        _createTextVNode("   " + _toDisplayString(_unref(t)('nav.toggle')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "mobile-fullscreen",
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openFullscreen()))
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "glyphicon glyphicon-fullscreen" }, null, -1)),
                    _cache[19] || (_cache[19] = _createTextVNode("   ")),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('nav.fullscreen')), 1)
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "mobile-fullscreen",
                    href: "#",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).commit('toggleTheme')))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["glyphicon glyphicon-asterisk", _unref(store).state.dark ? 'fas fa-sun' : 'fas fa-moon'])
                    }, null, 2)
                  ])
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("ul", {
            class: _normalizeClass(["nav navbar-nav navbar-right navbar-options", { 'dark-mode': _unref(store).state.dark }])
          }, [
            (_unref(route).path === '/')
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass([_ctx.$store.state.locale == 'en' ? 'dropdown-padding' : 'hidden'])
                }, [
                  _createVNode(_component_Dropdown, {
                    class: _normalizeClass(["locale-switcher p-dropdown-trigger-icon", { 'dark-mode': _unref(store).state.dark }]),
                    panelClass: { 'dark-mode': _unref(store).state.dark },
                    modelValue: selectedWar.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedWar).value = $event)),
                    options: conflicts,
                    optionLabel: "name",
                    optionValue: "value"
                  }, {
                    value: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(formatWarName(_unref(store).state.war)), 1)
                      ])
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                        _createElementVNode("span", { class: "p-dropdown-trigger-icon" }, [
                          _createElementVNode("i", { class: "pi-angle-down" })
                        ])
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["class", "panelClass", "modelValue"])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              class: _normalizeClass([_ctx.$store.state.war == '1948-arab-israeli-war' ? 'dropdown-padding' : 'hidden'])
            }, [
              _createVNode(_component_Dropdown, {
                class: _normalizeClass(["locale-switcher p-dropdown-trigger-icon", { 'dark-mode': _unref(store).state.dark }]),
                panelClass: { 'dark-mode': _unref(store).state.dark },
                modelValue: _unref(locale),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
                options: languages,
                optionLabel: "name",
                optionValue: "value"
              }, {
                value: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("img", {
                      class: "flag-select",
                      alt: slotProps.placeholder,
                      src: require(`@/assets/icons/${slotProps.value}.svg`)
                    }, null, 8, _hoisted_22),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(slotProps.value.toUpperCase()), 1)
                  ])
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("img", {
                      class: "flag-dropdown",
                      alt: slotProps.option.name,
                      src: require(`@/assets/icons/${slotProps.option.value}.svg`)
                    }, null, 8, _hoisted_25),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "p-dropdown-trigger-icon" }, [
                      _createElementVNode("i", { class: "pi-angle-down" })
                    ])
                  ], -1))
                ]),
                _: 1
              }, 8, ["class", "panelClass", "modelValue"])
            ], 2),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(store).commit('toggleTheme')))
              }, [
                _createElementVNode("span", {
                  style: {"font-size":"16px"},
                  class: _normalizeClass(["glyphicon glyphicon-asterisk", _unref(store).state.dark ? 'fas fa-sun' : 'fas fa-moon'])
                }, null, 2)
              ])
            ]),
            (_unref(route).path === '/')
              ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSidebar(_unref(store).state.view == 'map' ? 'sidebar' : 'map')))
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "glyphicon glyphicon-align-right" }, null, -1)),
                    _createTextVNode("   " + _toDisplayString(_unref(t)('nav.toggle')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "desktop-fullscreen",
                href: "#",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (openFullscreen()))
              }, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "glyphicon glyphicon-fullscreen" }, null, -1)),
                _cache[24] || (_cache[24] = _createTextVNode("   ")),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('nav.fullscreen')), 1)
              ])
            ])
          ], 2)
        ], 2)
      ])
    ], 2),
    _createElementVNode("div", {
      id: "mobile-nav",
      class: _normalizeClass({ 'dark-mode': _unref(store).state.dark })
    }, [
      _createElementVNode("button", {
        id: "showMap",
        class: _normalizeClass(["mobile-nav-button", _ctx.$store.state.view == 'map' ? 'mobile-active' : '']),
        onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleSidebar('map')))
      }, _toDisplayString(_unref(t)('nav.mobile.map')), 3),
      _createElementVNode("button", {
        id: "showSidebar",
        class: _normalizeClass(["mobile-nav-button", _ctx.$store.state.view == 'sidebar' ? 'mobile-active' : '']),
        onClick: _cache[11] || (_cache[11] = ($event: any) => (toggleSidebar('sidebar')))
      }, _toDisplayString(_unref(t)('nav.mobile.sidebar')), 3)
    ], 2)
  ]))
}
}

})